import { render } from "./DashboardSidebar.vue?vue&type=template&id=28dc538e&scoped=true&ts=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=ts"
export * from "./DashboardSidebar.vue?vue&type=script&lang=ts"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=28dc538e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dc538e"]])

export default __exports__